import React from "react";
import axios from "axios";
import { Routes, Route, Navigate } from "react-router-dom";
import { ClerkProvider, useAuth } from "@clerk/clerk-react";

import { About } from "./pages/About";
import { Login } from "./pages/Login";
import { Signup } from "./pages/Signup";
import { Search } from "./pages/Search";
import { AlbumPage } from "./pages/AlbumPage";
import { FriendsTab } from "./pages/Friends";
import { ProfileTab } from "./pages/Profile";
import { FriendExchangeTab } from "./pages/FriendExchange";
import { ProfileLayout } from "./layouts/ProfileLayout";
import { Homepage } from "./pages/Homepage";

function AuthSetup() {
    const { getToken } = useAuth();

    React.useEffect(() => {
        const interceptor = axios.interceptors.request.use(async (config) => {
            const method = config.method?.toLowerCase();

            // Only attach auth to mutations — avoids CORS preflight on GET requests
            if (method !== "post") {
                return config;
            }

            try {
                const token = await getToken();

                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
            } catch (error) {
                console.error("Failed to attach auth token:", error);
            }

            return config;
        });

        return () => {
            axios.interceptors.request.eject(interceptor);
        };
    }, [getToken]);

    return null;
}

function App() {
    // Import your Publishable Key
    const PUBLISHABLE_KEY = process.env.REACT_APP_VITE_CLERK_PUBLISHABLE_KEY;

    if (!PUBLISHABLE_KEY) {
        throw new Error("Missing Publishable Key");
    }

    return (
        <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
            <AuthSetup />
            <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="/about" element={<About />} />
                <Route path="/login" element={<Login />} />
                <Route path="/sign-up" element={<Signup />} />
                <Route path="/search" element={<Search />} />
                <Route path="/album/:albumId" element={<AlbumPage />} />

                <Route path="/:username" element={<ProfileLayout />}>
                    <Route index element={<Navigate to="listened" replace />} />
                    <Route path="shared" element={<ProfileTab />} />
                    <Route path="listened" element={<ProfileTab />} />
                    <Route path="history" element={<FriendExchangeTab />} />
                    <Route path="friends" element={<FriendsTab />} />
                </Route>
            </Routes>
        </ClerkProvider>
    );
}

export default App;
